import { API_TYPES } from "@src/appV2/api";
import { z } from "zod";

export const DISPUTE_REASON = {
  ATTENDED_INTERVIEW: "attended_interview",
  EMERGENCY: "emergency",
  OTHER: "other",
} as const;
export type DisputeReason = (typeof DISPUTE_REASON)[keyof typeof DISPUTE_REASON];

export const BAN_DISPUTE_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;
export type BanDisputeStatus = (typeof BAN_DISPUTE_STATUS)[keyof typeof BAN_DISPUTE_STATUS];

export const createDisputeRequestSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.placementCandidateBan),
    id: z.string(),
    attributes: z.object({
      dispute: z.object({
        reason: z.nativeEnum(DISPUTE_REASON),
        description: z.string(),
        evidenceFileKey: z.string().optional(),
      }),
    }),
  }),
});

export type CreateDisputeRequest = z.infer<typeof createDisputeRequestSchema>;
